import { keywords, label } from 'constants/regex';
import { Base64 } from 'js-base64';
import * as Yup from 'yup';

export const initialValues = {
  language: 'en',
  department: '',
  subject: '',
  message: '',
  label: '',
  keywords: '',
};

export const validationSchema = Yup.object({
  language: Yup.string().required('Please select any one'),
  //department: Yup.string().required('Please select any one'),
  subject: Yup.string().required('Please write subject'),
  message: Yup.string().required('Please write message'),
  label: Yup.string().required('Please write label').matches(label, 'Label format is not correct'),
  keywords: Yup.string().required('Please write keywords').matches(keywords, 'Keywords format is not correct'),
});

export const editInitialValues = (data) => {
  const { macros } = data || {};
  return {
    language: macros[0]?.language,
    department: macros[0]?.department,
    subject: Base64.decode(macros[0]?.subject),
    message: Base64.decode(macros[0]?.body),
    label: macros[0]?.label,
    keywords: macros[0]?.keywords,
  };
};
